import { Dialog, DialogActions, DialogContent, Grid } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import { makeStyles } from "@material-ui/styles";
import Moment from "moment";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import EnhancedConfirmButton from "src/components/enhanced/EnhancedConfirmButton";
import EnhancedTextField from "src/components/enhanced/EnhancedTextField";
import {fetchPassLogPrices} from "src/features/paymentSlice";
import { insertPassLog } from "src/features/passLogSlice";
import alertHelper from "src/helpers/alertHelper";
import PaymentTypeResolver from "src/helpers/paymentTypeResolver";
import { getSessionCheckedCompany } from "src/helpers/sessionHelper";
import EnhancedDialogTitle from "src/components/enhanced/EnhancedDialogTitle";
import EnhancedTicketPayment from "src/components/enhanced/EnhancedTicketPayment";
import EnhancedDateField from "src/components/enhanced/EnhancedDateField";

function NewPassLogDialog(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { open, setOpenNew } = props;
  const [formState, setFormState] = useState({});
  const [startDate] = useState(new Moment().add(12, "months").format("YYYY-MM-DD"));

  const handleChange = (event) => {
    event.persist();
    setFormState((formState) => ({
      ...formState,
      [event.target.name]: event.target.value
    }));
  };

  const handleClose = () => {
    setOpenNew(false);
    setFormState({});
  };

  const handlePayAndSave = () => {
    if (!formState.title) {
      alertHelper.error({ message: "Musíte zadat titulek permanentky!" });
      return false;
    }

    if (!formState.paymentTypeId) {
      alertHelper.error({ message: "Musíte zadat typ platby!" });
      return false;
    }

    if (PaymentTypeResolver.isBill(formState.paymentTypeId) && !formState.billNumber) {
      alertHelper.error({ message: "Musíte zadat číslo faktury!" });
      return false;
    }

    if (!formState.typeOfMassageId) {
      alertHelper.error({ message: "Musíte zadat typ masáže!" });
      return false;
    }

    const apiData = {
      companyId: getSessionCheckedCompany(),
      title: formState.title,
      dateExpire: formState.dateExpire || startDate,
      paymentTypeId: formState.paymentTypeId,
      massageTypeId: formState.typeOfMassageId,
      billUUID: formState.billNumber,
      note: formState.note,
      invoiceAddress: formState.invoiceAddress
    };

    alertHelper.confirm({
      message: "Opravdu si přejete uložit a zaplatit permanentku?",
      callback: () => dispatch(insertPassLog(apiData))
    });

    handleClose();
  };

  return (
    <div className={classes.root}>
      <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth="md" aria-labelledby="form-dialog-title">
        <EnhancedDialogTitle handleClose={handleClose} nameLabel="Vložit novou permanentku" />
        <DialogContent>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <EnhancedTextField name="title" value={formState.title} label="Jméno" onChange={handleChange} />
            </Grid>
            <Grid item xs={6}>
              <EnhancedDateField
                  name="dateExpire"
                  label="Platnost do"
                  value={formState.dateExpire || startDate}
                  handleChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <EnhancedTextField
                  name="note"
                  value={formState.note}
                  label="Poznámka"
                  onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <EnhancedTicketPayment
                formState={formState}
                open={open}
                handleChange={handleChange}
                disabled={false}
                fetchPriceMethod={fetchPassLogPrices}
            />
          </Grid>
        </DialogContent>
        <DialogActions>
          <EnhancedConfirmButton handleOk={handlePayAndSave} okLabel="Uložit a zaplatit" />
        </DialogActions>
      </Dialog>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1
  }
}));

export default NewPassLogDialog;
